export const formatAppointmentDate = (
  appointmentDate: string,
  appointmentTime: string,
  abbreviatedTimeZone?: string
): string => {
  const rawDateTime = `${appointmentDate}T${appointmentTime}`;
  const dateTime = new Date(rawDateTime);

  // Create a formatter for the desired format (excluding time zone)
  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true, // Use 12-hour time format
  });

  // Format the date and time (excluding time zone)
  const formattedDateWithoutTimeZone = formatter.format(dateTime);

  return `${formattedDateWithoutTimeZone} ${abbreviatedTimeZone ?? ''}`;
};
